import React from "react";
import { Box, Body2 } from "@sainsburys-tech/fable";
import StatusLabel from "../StatusLabel";
import LastUpdate from "../LastUpdate";

const StoreLightingControlPanelItem = props => {
  const description =
    props.storeStatus.commissioningStatus !== null
      ? props.storeStatus.commissioningStatus.description
      : null;

  const parseGatewayLastOnline = () => {
    return props.storeStatus.gatewayLastOnline > new Date()
      ? new Date()
      : props.storeStatus.gatewayLastOnline;
  };

  return (
    <a
      href={`/lighting/stores/${props.storeId}/commissioning`}
      className="cb-c-store-lighting-control-panel-item__card fable:block"
      style={{ textDecoration: "none" }}
    >
      <Box>
        <h4>Lighting Control Panel</h4>
        <h2>{props.usage}</h2>
        <span className="cb-c-store-lighting-control-panel-item__store-status">
          Store Status
        </span>
        <div>
          <b>{description}</b>
        </div>
        {!props.storeStatus.gatewayOnline && (
          <div className="fable:mt-16">
            <StatusLabel
              status="error"
              label="Currently offline"
              icon="offline"
            />
          </div>
        )}
        <span className="cb-c-store-lighting-control-panel-item__last-update">
          <Body2>
            Last updated <LastUpdate>{parseGatewayLastOnline()}</LastUpdate>
          </Body2>
        </span>
      </Box>
    </a>
  );
};

export default StoreLightingControlPanelItem;
